export default {
  'purchasesAbcCurveReport.form.filterByDate': 'Filter By Date',
  'purchasesAbcCurveReport.form.filterByDate.launch': 'Launch',
  'purchasesAbcCurveReport.form.filterByDate.emission': 'Emission',

  'purchasesAbcCurveReport.form.classificationByImportance':
    'Classification By Importance',
  'purchasesAbcCurveReport.form.classificationByImportance.quantity':
    'Quantity',
  'purchasesAbcCurveReport.form.classificationByImportance.value': 'Value',
};
